import React, { FunctionComponent } from 'react'
import { CheckoutState, useAppRouter, useCheckoutState, useCrossBorderTrade } from '../../state'
import styles from '../OrderDetails/style.module.css'
import { Text, DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'
import { Money } from '../Money'
import { useCheckoutSizes } from '../../utils/responsive'
import { Trans } from '../../utils/convergence'

export const OrderConversionBreakdown: FunctionComponent = () => {
  const { isCrossBorder, exchangeRate } = useCrossBorderTrade()
  const { locale } = useAppRouter()
  const { textSize } = useCheckoutSizes()
  const state: CheckoutState = useCheckoutState()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)

  if (!isCrossBorder || isArcadeDesignLanguage) {
    return null
  }

  return (
    <div className={styles.forex}>
      <Text color='Gray40' className={styles.moneyText}>
        <Trans
          i18nKey='orders:orderSummary:exchange'
          values={{ exchange: exchangeRate }}
          components={{ amount: <Money locale={locale} size={textSize} value={state.started?.merchantAmount} /> }}
        />
      </Text>
    </div>
  )
}
